<template>
  <div>
    <v-checkbox
      v-for="choice in currentQuestion.data.choices"
      :key="choice"
      v-model="answers"
      :value="choice"
      :label="choice"
    >
    </v-checkbox>
    <v-checkbox
      v-if="currentQuestion.data.otherChoice"
      :label="currentQuestion.data.otherLabel"
      v-model="answers"
      :value="currentQuestion.data.otherLabel"
    ></v-checkbox>
    <v-text-field
      label="Précisez"
      v-model="comment"
      v-if="answers.includes(currentQuestion.data.otherLabel)"
      style="margin-top: -1.5rem; margin-left: 2.3rem;"
      required
      single-line
    ></v-text-field>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import _ from 'lodash';

  export default {
    name: "MultiChoice",
    data: () => ({
      answers: [],
      comment: ``,
    }),
    computed: {
      ...mapState([
        `currentQuestion`,
      ]),
    },
    methods: {
      clear () {
        this.answers = [];
        this.comment = null;
      },
    },
    watch: {
      answers (newAnswers) {
        let canValidate = newAnswers.length > 0;
        if (newAnswers.includes(this.currentQuestion.data.otherLabel)) {
          canValidate = canValidate && Boolean(this.comment);
          let otherAnswer = _.find(newAnswers, this.currentQuestion.data.otherLabel);
          otherAnswer = `${otherAnswer} : ${this.comment}`;
        } else {
          this.comment = ``;
        }
        this.$emit(`canValidate`, canValidate);
        this.$emit(`newAnswer`, newAnswers);
      },
      comment (newComment) {
        if (this.answers.includes(this.currentQuestion.data.otherLabel)) {
          const answers = [...this.answers];
          let otherAnswer = _.remove(answers, this.currentQuestion.data.otherLabel)[0];
          otherAnswer = `${otherAnswer} : ${this.comment}`;
          answers.push(otherAnswer);
          this.$emit(`canValidate`, Boolean(newComment));
          this.$emit(`newAnswer`, answers);
        }
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MultiChoice.vue?08333fb9